import type { FC, ReactNode } from 'react';

interface Props {
  description?: ReactNode;
  leading?: ReactNode;
  title: string;
  trailing?: ReactNode;
}

export const displayName: string = 'Design System/ListItem';

const ListItem: FC<Props> = (props) => {
  const { description, leading, title, trailing } = props;

  return (
    <li className="flex items-center justify-between gap-4 px-4 py-3" data-component="list-item">
      <div className="flex items-center min-w-0 gap-3">
        {leading && <div className="text-base shrink-0 text-grey-base">{leading}</div>}
        <div className="min-w-0">
          <div className="text-sm">{title}</div>
          {description && <div className="text-xs text-grey-base">{description}</div>}
        </div>
      </div>
      {trailing && <div className="shrink-0">{trailing}</div>}
    </li>
  );
};

export type { Props as ListItemProps };
export default ListItem;
